package kz.dentalcrm.app.screens.employees.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface EmployeesViewEvent : ViewEvent {

    data class NavigateToEmployeeDetail(
        val employeeId: String
    ) : EmployeesViewEvent

    data object LoadMoreEmployees : EmployeesViewEvent

    data object Refresh : EmployeesViewEvent

    data object OpenPositions : EmployeesViewEvent

    data object NavigateToNewEmployee : EmployeesViewEvent

}